<template>
  <transition name="fade">
    <div
      class="container-sidebar-bg width-100 height-100 display-flex"
      v-if="showSidebar"
    >
      <!-- <v-btn
        icon
        dark
        class="button-close"
        @click="$store.commit('setShowSidebar', false)"
      >
        <v-icon
          color="#FFFFFF"
          size="25px"
        >
          mdi-close
        </v-icon>
      </v-btn> -->
      <div class="container-sidebar">
        <div class="content-image">
          <img
            src="@/assets/images/logo-bg-black.svg"
            alt=""
          >
        </div>
        <div
          :style="{ height: screenHeight + 'px', overflow: 'auto' }"
          class="pl-5 pr-5"
        >
          <v-btn
            @click="redirectHome"
            :class="($route.path == '/home') ? 'button-selected buttons-sidebar mt-2': 'buttons-sidebar mt-2'"
            active-class="button-selected"
            elevation="0"
            style="padding-left: 12px !important"
          >
            <v-icon
              color="#FFFFFF"
              size="22px"
            >
              mdi-home-variant-outline
            </v-icon>
            <p class="sidebar-title mon-regular ml-3">{{ texts.sidebar.textHome }}</p>
            <div
              v-if="$route.path == '/home'"
              class="active-line"
            />
          </v-btn>
          <v-btn
            @click="redirectArticle"
            :class="($route.path == '/articles') ? 'button-selected buttons-sidebar mt-2': 'buttons-sidebar mt-2'"
            active-class="button-selected"
            elevation="0"
            style="padding-left: 12px !important"
          >
            <v-icon
              color="#FFFFFF"
              size="22px"
            >
              mdi-view-grid
            </v-icon>
            <p class="sidebar-title mon-regular ml-3">{{ texts.sidebar.textArticle }}</p>
            <div
              v-if="$route.path == '/articles'"
              class="active-line"
            />
          </v-btn>
          <v-btn
            @click="redirectOrders"
            :class="($route.path == '/orders') ? 'button-selected buttons-sidebar mt-2': 'buttons-sidebar mt-2'"
            active-class="button-selected"
            elevation="0"
            style="padding-left: 12px !important"
          >
            <v-icon
              color="#FFFFFF"
              size="22px"
            >
              mdi-bookmark-outline
            </v-icon>
            <p class="sidebar-title mon-regular ml-3">{{ texts.sidebar.textPurchaseOrder }}</p>
            <div
              v-if="$route.path == '/orders'"
              class="active-line"
            />
          </v-btn>
          <!-- <v-btn
            class="buttons-sidebar mt-2"
            active-class="button-selected"
            elevation="0"
          >
            <img
              width="12px"
              src="@/assets/icons/book.svg"
              alt=""
            >
            <p class="sidebar-title mon-regular ml-3">{{ texts.sidebar.textHistorialPurchaseOrder }}</p>
          </v-btn> -->
          <v-btn
            @click="redirectDisputes"
            :class="($route.path == '/disputes') ? 'button-selected buttons-sidebar mt-2': 'buttons-sidebar mt-2'"
            active-class="button-selected"
            elevation="0"
          >
            <img
              width="17px"
              src="@/assets/icons/alert.svg"
              alt=""
            >
            <p class="sidebar-title mon-regular ml-3">{{ texts.sidebar.textHistorialDisputes }}</p>
            <div
              v-if="$route.path == '/disputes'"
              class="active-line"
            />
          </v-btn>
          <v-btn
            @click="redirectWarehouses"
            :class="($route.path == '/warehouses') ? 'button-selected buttons-sidebar mt-2': 'buttons-sidebar mt-2'"
            active-class="button-selected"
            elevation="0"
          >
            <v-icon
              color="#FFFFFF"
              size="17px"
            >
              mdi-archive-outline
            </v-icon>
            <p class="sidebar-title mon-regular ml-3">{{ texts.sidebar.textWarehouses }}</p>
            <div
              v-if="$route.path == '/warehouses'"
              class="active-line"
            />
          </v-btn>
          <v-btn
            v-if="$store.state.isManager"
            @click="redirectUsers"
            :class="($route.path == '/users') ? 'button-selected buttons-sidebar mt-2': 'buttons-sidebar mt-2'"
            active-class="button-selected"
            elevation="0"
          >
            <img
              width="13px"
              src="@/assets/icons/user.svg"
              alt=""
            >
            <p class="sidebar-title mon-regular ml-3">{{ texts.sidebar.textUsers }}</p>
            <div
              v-if="$route.path == '/users'"
              class="active-line"
            />
          </v-btn>
          <v-btn
            @click="redirectUserProfile"
            :class="($route.path == '/user-profile') ? 'button-selected buttons-sidebar mt-2': 'buttons-sidebar mt-2'"
            active-class="button-selected"
            elevation="0"
          >
            <img
              width="15px"
              src="@/assets/icons/briefcase.svg"
              alt=""
            >
            <p class="sidebar-title mon-regular ml-3">{{ texts.sidebar.textProfile }}</p>
            <div
              v-if="$route.path == '/user-profile'"
              class="active-line"
            />
          </v-btn>
        </div>
        <div class="content-language text-center pl-5 pr-5">
          <v-btn
            @click="changeLanguage('en')"
            :class="(selectLanguage == 'en') ? 'button-selected buttons-sidebar mt-2': 'buttons-sidebar mt-2'"
            elevation="0"
          >
            <img
              width="18px"
              src="@/assets/icons/eu.svg"
              alt=""
            >
            <p class="sidebar-title mon-regular ml-3">{{ texts.sidebar.textEnLang }}</p>
          </v-btn>
          <v-btn
            style
            @click="changeLanguage('sp');"
            :class="(selectLanguage == 'sp') ? 'button-selected buttons-sidebar mt-2 mb-2': 'buttons-sidebar mt-2 mb-2'"
            elevation="0"
          >
            <img
              width="18px"
              src="@/assets/icons/mx.svg"
              alt=""
            >
            <p class="sidebar-title mon-regular ml-3">{{ texts.sidebar.textSpLang }}</p>
          </v-btn>
        </div>
        <div class="text-center pl-5 pr-5">
          <v-btn
            @click="$store.commit('setShowSidebar', false); closeSession();"
            class="buttons-sidebar mt-2 mb-2"
            active-class="button-selected"
            elevation="0"
          >
            <img
              width="16px"
              src="@/assets/icons/close.svg"
              alt=""
            >
            <p class="sidebar-title mon-regular ml-3">{{ texts.sidebar.textCloseSession }}</p>
          </v-btn>
        </div>
      </div>
      <div
        class="bg-close"
        @click="$store.commit('setShowSidebar', false)"
      ></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "SidebarOpenComponent",
  data() {
    return {
      //VARIABLES
      screenHeight: 0,
      texts: "",
    };
  },
  beforeMount() {
    this.texts = FILE.sidebar[this.selectLanguage];
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    changeLanguage: function (e) {
      const config = {
          headers: {
            Authorization: `Bearer ${this.$store.state.sToken}`,
          },
        },
        payload = {};

      DB.patch(
        `${URI}/api/v1/${e}/users/${this.$store.state.sUserId}/languages`,
        payload,
        config
      )
        .then((response) => {
          this.$store.commit("toggle_language", e);
          this.$store.commit("setShowSidebar", false);
        })
        .catch((error) => {
        });
    },
    redirectHome: function () {
      const self = this;

      this.$router.push("/home");
      setTimeout(function () {
        self.$store.commit("setShowSidebar", false);
      }, 200);
    },
    redirectArticle: function () {
      const self = this;

      this.$router.push("/articles");
      setTimeout(function () {
        self.$store.commit("setShowSidebar", false);
      }, 200);
    },
    redirectOrders: function () {
      const self = this;

      this.$router.push("/orders");
      setTimeout(function () {
        self.$store.commit("setShowSidebar", false);
      }, 200);
    },
    redirectDisputes: function () {
      const self = this;

      this.$router.push("/disputes");
      setTimeout(function () {
        self.$store.commit("setShowSidebar", false);
      }, 200);
    },
    redirectUserProfile: function () {
      const self = this;

      this.$router.push("/user-profile");
      setTimeout(function () {
        self.$store.commit("setShowSidebar", false);
      }, 200);
    },
    redirectWarehouses: function () {
      const self = this;

      this.$router.push("/warehouses");
      setTimeout(function () {
        self.$store.commit("setShowSidebar", false);
      }, 200);
    },
    redirectUsers: function () {
      const self = this;

      this.$router.push("/users");
      setTimeout(function () {
        self.$store.commit("setShowSidebar", false);
      }, 200);
    },
    closeSession: function () {
      if (this.$store.state.sToken !== "") {
        const config = {
          headers: {
            Authorization: `Bearer ${this.$store.state.sToken}`,
          },
        };

        DB.delete(`${URI}/api/v1/${this.selectLanguage}/session`, config)
          .then((response) => {
            const self = this;

            localStorage.clear();
            this.$store.commit("setIsLogged", false);
            this.$store.commit("setToken", "");
            this.$store.commit("setFullName", "");
            this.$store.commit("setEnterpriseId", "");
            this.$store.commit("setUserId", "");

            setTimeout(function () {
              self.mixSuccess(response.data.message);
            }, 200);
            setTimeout(function () {
              self.$router
                .push({
                  name: "Login",
                })
                .catch(() => {});
            }, 400);
          })
          .catch((error) => {
            this.mixError(error.response.data.message, error.response.status);
          });
      }
    },
    handleResize: function () {
      this.screenHeight = window.innerHeight - 258;
      if (window.innerWidth < 600) {
        this.$store.commit("setShowSidebar", false);
      }
    },
  },
  computed: {
    showSidebar: function () {
      return this.$store.state.showSidebar;
    },
    selectLanguage: function () {
      return this.$store.state.language;
    },
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.sidebar[this.selectLanguage];
      }
    },
  },
};
</script>

<style scoped>
.active-line {
  width: 10px;
  height: 45px;
  position: absolute;
  left: -35px;
  background: transparent linear-gradient(10deg, #fffc81 0%, #7eff86 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 0px 11px 11px 0px;
}

.button-close {
  position: absolute;
  left: 290px;
  top: 15px;
  background-color: #283c4d !important;
}

.sidebar-title {
  text-align: left;
  font-size: 16px;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  margin-bottom: 0px;
  text-transform: initial;
}

.buttons-sidebar {
  background-color: transparent !important;
  width: 100% !important;
  height: 50px !important;
  justify-content: flex-start;
}

.button-selected {
  border-radius: 13px;
  background-color: #283c4d !important;
}

.content-language {
  border: 2px solid #283c4d;
}

.content-image {
  width: 100%;
  height: 65px;
  border: 2px solid #283c4d;
}

.content-image img {
  width: 100%;
  height: auto;
}

@supports (object-fit: contain) {
  .content-image img {
    height: 100%;
    object-fit: contain;
    object-position: center center;
  }
}

.container-sidebar {
  width: 320px;
  background-color: #304458;
}

.container-sidebar-bg {
  position: absolute;
  top: 0px;
  z-index: 99999;
}
.bg-close:hover {
  cursor: pointer;
}

.bg-close {
  background-color: #00000090;
  width: 100%;
  height: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>